<template>
    <GChart
        type="LineChart"
        :data="speedChartData"
        :options="speedChartOptions"
        style="height: 150px; width: 100% !important;"
        @ready="drawGraph"
    >
    </GChart>
</template>

<script>

import moment from 'moment'
import { calculateSpeedOrDistanceUnit } from '@/helpers/Utils'
import { mapGetters } from 'vuex'

export default {
    name: 'SpeedGraph',
    mounted () {
        this.speedChartOptions.vAxis.title = 0 === this.getSpeedUnit ? 'Speed [kph]' : 'Speed [mph]'
    },
    props: {
        journeys: {
            required: true
        }
    },
    data () {
        return {
            speedChartOptions: {
                legend: { position: 'bottom' },
                hAxis: {
                    title: 'Time'
                },
                vAxis: {
                    title: 'Speed'
                },
                chartArea: {
                    left: 60,
                    top: 20,
                    width: '100%',
                    height: '80%'
                },
                height: 150,
                backgroundColor: 'transparent',
                focusTarget: 'category'
            },
            speedChartData: []
        }
    },
    computed: {
        ...mapGetters({
            getSpeedUnit: 'authModule/getSpeedUnit'
        })
    },
    methods: {
        async drawGraph (chart, google) {
            this.speedChartData = await new google.visualization.DataTable()
            this.speedChartData.addColumn('string', 'Time')
            this.speedChartData.addColumn('number', 'Speed')
            this.speedChartData.addColumn('number', 'Limit')

            this.journeys.speedingTimelineBlocks.forEach(journey => {
                let date = moment(journey.utc).format('YYYY-MM-DD HH:mm:ss')
                this.speedChartData.addRow([
                    date,
                    0 === this.getSpeedUnit ? journey.speed : calculateSpeedOrDistanceUnit(journey.speed, 'mi'),
                    0 === this.getSpeedUnit ? journey.speedLimit || 0 : calculateSpeedOrDistanceUnit(journey.speedLimit || 0, 'mi')
                ])
            })
        }
    }
}
</script>

<style scoped>

</style>
